import { useQuery } from 'react-query'
import { useSnackbar } from 'notistack'
import {
  getNordicLookupsUsage,
  NordicLookupsUsageParams,
} from 'services/cm-api/get-nordic-lookups-usage'

export function useNordicLookupsUsage(params: NordicLookupsUsageParams = {}) {
  const { enqueueSnackbar } = useSnackbar()

  return useQuery(
    ['getNordicLookupsUsage', params],
    () => getNordicLookupsUsage(params),
    {
      enabled: Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
      keepPreviousData: true,
      staleTime: 60_000,
      onError: (err) => {
        enqueueSnackbar('Cannot get Nordic lookups usage', { variant: 'error' })
        console.error('Failed to fetch Nordic lookups usage:', err)
      },
    },
  )
}
